let css = require('./header.css');
let CountHeader = require('../../filterable-tree/count-header');

class RubricsHeader {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }
}

module.exports = {
    constructor: RubricsHeader,
    children: [
        {
            name: 'count-header',
            component: CountHeader,
            props: {
                pluralized: ['рубрика', 'рубрики', 'рубрик'],
                defaultTitle: 'Выберите рубрику'
            },
            watcher: {
                leafs: ['order', 'rubrics', 'tree', 'computed', 'leafs'],
                selected: ['order', 'rubrics', 'tree', 'selected']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/common/custom-order/rubrics/header/index.js